import { render, staticRenderFns } from "./GroupTickets.vue?vue&type=template&id=45533b8e&scoped=true&"
import script from "./GroupTickets.vue?vue&type=script&lang=ts&"
export * from "./GroupTickets.vue?vue&type=script&lang=ts&"
import style0 from "./GroupTickets.vue?vue&type=style&index=0&id=45533b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45533b8e",
  null
  
)

export default component.exports